import React from 'react';
import SingleDatePicker from 'react-dates/esm/components/SingleDatePicker';
import uniqueId from 'lodash/uniqueId';

export const PvDatePicker = (props) => (
  <SingleDatePicker
    date={props.date} // momentPropTypes.momentObj or null
    onDateChange={props.onDateChangeFn} // PropTypes.func.isRequired
    focused={props.focused}
    onFocusChange={props.onFocusChangeFn} // PropTypes.func.isRequired
    id={uniqueId('datepicker_')}
    inputIconPosition='after'
    hideKeyboardShortcutsPanel={true}
    numberOfMonths={1}
    enableOutsideDays={true}
    isOutsideRange={() => false}
    noBorder={true}
    showDefaultInputIcon={props.showDefaultInputIcon !== undefined ? props.showDefaultInputIcon : true}
    disabled={props.disabled}
    isDayBlocked={props.isDayBlocked}
  />
);



// WEBPACK FOOTER //
// ./src/components/form/PvDatePicker.jsx